import  {
  CollectionStore2,
  ConnectionHttpService, HttpApiCollectionRepository,
  ListStore2, ReadonlyHttpApiCollectionRepository,
  ReadonlyHttpApiListRepository,
  ReadonlyRepositoryListStore2, RepositoryCollectionStore2, SOFTLINE_COLLECTION_REPOSITORY,
  SOFTLINE_LIST_REPOSITORY,
  Store2Builder,
  SubscriptionStore2
} from '@softline/core';
import { InjectionToken } from '@angular/core';
import {
  QueryStore2
} from '@softline/core';
import { SOFTLINE_API_KOPFAU_ENTITIES } from '../goldschmiede.api';
import { Kopfau, KopfauWithMetadata } from '../types/kopfau';
import { AuftragStoreAddon } from './auftragStoreAddon';

const auftragStore = new Store2Builder('auftrag')
  .withProvider({
    provide: SOFTLINE_LIST_REPOSITORY,
    useFactory: (service: ConnectionHttpService) =>
      new ReadonlyHttpApiListRepository(service, SOFTLINE_API_KOPFAU_ENTITIES),
    deps: [ConnectionHttpService]
  })
  .withProvider(
    {
      provide: SOFTLINE_COLLECTION_REPOSITORY,
      useFactory: (service: ConnectionHttpService) =>
        new HttpApiCollectionRepository(service, SOFTLINE_API_KOPFAU_ENTITIES),
      deps: [ConnectionHttpService] }
  )
  .withSubFeature('list', ListStore2<KopfauWithMetadata>)
  .withSubFeature('subscription', SubscriptionStore2)
  .withSubFeature('remote', ReadonlyRepositoryListStore2<KopfauWithMetadata>)
  .withSubFeature('query', QueryStore2<any>)
  .withSubFeature('collection', CollectionStore2<Kopfau>)
  .withSubFeature('collectionRemote', RepositoryCollectionStore2<KopfauWithMetadata>)
  .withSubFeature('auftragStoreAddon', AuftragStoreAddon<Kopfau>)


export const AuftragStore = new InjectionToken(
  'AuftragStore',
  {providedIn: 'root', factory: () => auftragStore.build()}
);
